import React from 'react'
import { Link } from 'react-router-dom'
import { withContext } from '../../context/withContext'

/**
 * Tarjeta grande con ícono redondo tipo dashboard (referencia de diseño móvil).
 */
const SectionCard = ({ to, label, icon, color = 'blue' }) => {
	const colorClasses = {
		blue: 'tw-from-blue-100 tw-to-blue-50 tw-text-blue-600 dark:tw-from-blue-900/40 dark:tw-to-blue-900/10 dark:tw-text-blue-300',
		green: 'tw-from-emerald-100 tw-to-emerald-50 tw-text-emerald-600 dark:tw-from-emerald-900/40 dark:tw-to-emerald-900/10 dark:tw-text-emerald-300',
		purple: 'tw-from-purple-100 tw-to-purple-50 tw-text-purple-600 dark:tw-from-purple-900/40 dark:tw-to-purple-900/10 dark:tw-text-purple-300',
		orange: 'tw-from-orange-100 tw-to-orange-50 tw-text-orange-600 dark:tw-from-orange-900/40 dark:tw-to-orange-900/10 dark:tw-text-orange-300',
		pink: 'tw-from-pink-100 tw-to-pink-50 tw-text-pink-600 dark:tw-from-pink-900/40 dark:tw-to-pink-900/10 dark:tw-text-pink-300',
		cyan: 'tw-from-cyan-100 tw-to-cyan-50 tw-text-cyan-600 dark:tw-from-cyan-900/40 dark:tw-to-cyan-900/10 dark:tw-text-cyan-300',
		indigo: 'tw-from-indigo-100 tw-to-indigo-50 tw-text-indigo-600 dark:tw-from-indigo-900/40 dark:tw-to-indigo-900/10 dark:tw-text-indigo-300',
		yellow: 'tw-from-amber-100 tw-to-amber-50 tw-text-amber-600 dark:tw-from-amber-900/40 dark:tw-to-amber-900/10 dark:tw-text-amber-300',
	}

	return (
		<Link
			to={to}
			className="tw-group tw-flex tw-flex-col tw-items-center tw-justify-center tw-gap-3 tw-rounded-2xl tw-bg-white tw-p-5 sm:tw-p-6 tw-shadow-sm tw-border tw-border-gray-100 tw-transition-all hover:tw-shadow-md hover:tw--translate-y-0.5 dark:tw-bg-gray-800 dark:tw-border-gray-700">
			<div
				className={`tw-h-16 tw-w-16 sm:tw-h-20 sm:tw-w-20 tw-rounded-full tw-bg-gradient-to-br ${colorClasses[color]} tw-flex tw-items-center tw-justify-center tw-transition-transform group-hover:tw-scale-105`}>
				<i className={`${icon} tw-text-2xl sm:tw-text-3xl`}></i>
			</div>
			<p className="tw-text-center tw-text-sm sm:tw-text-base tw-font-medium tw-text-gray-700 dark:tw-text-gray-200">
				{label}
			</p>
		</Link>
	)
}

/**
 * Homepage del admin: grid de accesos rápidos.
 * Diseño mobile-first (grid 2 columnas en móvil, 4 en desktop).
 */
function Dashboard(props) {
	const user = props?.context?.user || {}
	const firstName = user.first_name || ''

	// Secciones que aparecen en el Topbar → grid de accesos rápidos
	const sections = [
		{ to: '/companies?sort=-timestamp&page=1', label: 'Compañías', icon: 'fas fa-building', color: 'blue' },
		{ to: '/users?page=1&sort=-date_joined', label: 'Usuarios', icon: 'fas fa-users', color: 'purple' },
		{ to: '/reports/subscriptions', label: 'Reportes', icon: 'fas fa-chart-line', color: 'green' },
		{ to: '/brik/global-config', label: 'Brik', icon: 'fas fa-robot', color: 'pink' },
		{ to: '/locations', label: 'Ubicaciones', icon: 'fas fa-map-marker-alt', color: 'orange' },
		{ to: '/properties', label: 'Propiedades', icon: 'fas fa-home', color: 'cyan' },
		{ to: '/sites', label: 'Sitios Web', icon: 'fas fa-globe', color: 'indigo' },
		{ to: '/settings/account', label: 'Ajustes', icon: 'fas fa-cog', color: 'yellow' },
	]

	return (
		<div className="tw-min-h-screen tw-bg-gray-50 dark:tw-bg-gray-900">
			<div className="tw-max-w-7xl tw-mx-auto tw-px-4 sm:tw-px-6 lg:tw-px-8 tw-py-6 sm:tw-py-8">
				{/* Hero */}
				<div className="tw-mb-6 sm:tw-mb-8">
					<h1 className="tw-text-2xl sm:tw-text-3xl tw-font-bold tw-text-gray-900 dark:tw-text-white">
						Hola{firstName ? `, ${firstName}` : ''} 👋
					</h1>
					<p className="tw-text-sm sm:tw-text-base tw-text-gray-500 dark:tw-text-gray-400 tw-mt-1">
						Bienvenido a AlterEstate Admin. Selecciona una sección para comenzar.
					</p>
				</div>

				{/* Grid de secciones */}
				<div className="tw-grid tw-grid-cols-2 sm:tw-grid-cols-3 md:tw-grid-cols-4 tw-gap-3 sm:tw-gap-4">
					{sections.map((s) => (
						<SectionCard key={s.label} to={s.to} label={s.label} icon={s.icon} color={s.color} />
					))}
				</div>
			</div>
		</div>
	)
}

export default withContext(Dashboard)
